import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Input } from '../../Elements/Elements';

import { validationNoSpecialCharacters } from 'utils/validation';

import classes from './InputWithEnter.module.scss';

const InputWithEnter = ({ placeholder, handleSubmit, className }) => {
  const [inputValue, setInputValue] = useState('');

  const onChange = e => {
    if (validationNoSpecialCharacters(e.target.value, 19)) {
      setInputValue(e.target.value);
    }
  };

  const onClearSearch = () => {
    setInputValue('');
  };

  const onSubmit = e => {
    e.preventDefault();
    if (inputValue && inputValue !== '') {
      setInputValue('');
      handleSubmit(inputValue);
    }
  };

  return (
    <form className={cn(classes.form, className)} onSubmit={onSubmit}>
      <Input
        input={{ value: inputValue, onChange: onChange }}
        placeholder={placeholder}
        className={classes.form_input}
      />
      {inputValue && (
        <div
          className={classes.clear}
          onClick={onClearSearch}
          aria-label={`clear search`}
        >
          <Icon icon="closeCircle" className={classes.clear_icon} size="16px" />
        </div>
      )}
    </form>
  );
};

InputWithEnter.propTypes = {
  placeholder: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default InputWithEnter;
